import * as React from "react"
import * as _ from "lodash"
import { connect } from "react-redux"
import { bindActionCreators, Dispatch } from "redux"
import { RouteComponentProps } from "react-router"
import InstructionListComponent, { ContextMenuItemCode } from "./instruction-list-component"
import * as actionCreators from "../../../../../action-creators"
import ApiError, { ApiErrorCode } from "../../../../../error/api-error"
import * as Model from "../../../../../model"
import { ReducerState, MappedActionsProps } from "../../../../../reducer"
import * as LacasService from "../../../../../service/sfp/lacas-service"
import * as InstructionsService from "../../../../../service/sfp/instructions-service-2"
import { NotificationLevel, NotificationProps } from "../../../../notification"
import { getProfile, Profile } from "../../../../../domain/sfp/user-domain"

class InstructionList
extends React.Component<InjectedProps, State> {
	private abortController = new AbortController()

	constructor(props) {
		super(props)

		this.state = {
			accountExist: false,
			accounts: [],
			addLaca: false,
			attachAccount: false,
			classes: [],
			chapters: [],
			editLaca: null,
			lacas: [],
			instruction: null,
			loading: false,
			loadingChapters: false,
			loadingUpdate: false,
			notification: null,
			submitting: false
		}
	}

	componentDidMount() {
		if(this.state.loading || this.state.loadingChapters) return
		this.initData(this.props)
	}

	componentWillReceiveProps(nextProps: Readonly<InjectedProps>) {
		if(this.state.loading || this.state.loadingChapters) return
		this.initData(nextProps)
	}
	shouldComponentUpdate(nextProps){
		if(this.props.currentLocalAuthority != nextProps.currentLocalAuthority ){
			this.initData(nextProps)
			return true
		}
		if(nextProps.loadingCurrentLocalAuthority &&this.props.loadingCurrentLocalAuthority !=nextProps.loadingCurrentLocalAuthority){
			this.setState({loading:false, submitting: false,addLaca: false})
		}
		if(!nextProps.loadingCurrentLocalAuthority &&this.props.loadingCurrentLocalAuthority !=nextProps.loadingCurrentLocalAuthority){
			this.setState({loading:true})
		}
		return true
	}
	componentWillUnmount() {
		this.abortController.abort()
	}

	render() {
		const consulted = getProfile(this.props.currentUser) === Profile.LocalAuthorityConsultant
		return <InstructionListComponent
		accounts={this.state.accounts}
		addLaca={this.state.addLaca}
		attachAccount={this.state.attachAccount}
		classes={this.state.classes}
		consulted={consulted}
		chapters={this.state.chapters}
		editLaca={this.state.editLaca}
		instruction={this.state.instruction}
		lacas={this.state.lacas}
		loading={this.state.loading}
		loadingChapters={this.state.loadingChapters}
		loadingUpdate={this.state.loadingUpdate}
		localAuthority={this.props.currentLocalAuthority}
		localAuthorities={this.props.localAuthorities}
		notification={this.state.notification}
		submitting={this.state.submitting}
		onClickAddAccount={e => this.handleClickAddAccount(e)}
		onClickAddAccountModalCloseButton={e => this.handleClickAddAccountModalCloseButton(e)}
		onClickAttachAccount={e => this.handleClickAttachAccount(e)}
		onClickAttachAccountModalCloseButton={e => this.handleClickAttachAccountModalCloseButton(e)}
		onClickContextMenu={(code, laca) => this.handleClickContextMenu(code, laca)}
		onClickNotificationCloseButton={e => this.handleClickCloseNotification(e)}
		onClickEditAccountModalCloseButton={e => this.handleClickEditAccountModalCloseButton(e)}
		onSubmitAddAccountModal={(account, chapter, e) => this.handleSubmitAddAccountModal(account, chapter, e)}
		onSubmitAttachAccountModal={(account, chapter, e) => this.handleSubmitAttachAccountModal(account, chapter, e)}
		onSubmitEditAccountModal={(laca, chapter, account, e) => this.handleSubmitEditAccountModal(laca, chapter, account,e)} />
	}

	private handleClickAddAccount(e: React.SyntheticEvent<Element>) {
		this.setState({ addLaca: true })
	}

	private handleClickAttachAccount(e: React.SyntheticEvent<Element>) {
		this.setState({ attachAccount: true})
	}

	private handleClickContextMenu(
		code: ContextMenuItemCode,
		laca: Model.LocalAuthorityChapterAccount
	): void {
		switch (code) {
			case ContextMenuItemCode.EditAccount:
				this.setState({ editLaca: laca })
				break
		}
	}

	private handleClickAddAccountModalCloseButton(e: React.SyntheticEvent<Element>): void {
		this.setState({ addLaca: null, notification: null })
	}

	private handleClickAttachAccountModalCloseButton(e: React.SyntheticEvent<Element>): void {
		this.setState({ attachAccount: null, notification: null })
	}
	private handleClickEditAccountModalCloseButton(e: React.SyntheticEvent<Element>): void {
		this.setState({ editLaca: null, notification: null })
	}

	private handleClickCloseNotification(e: React.SyntheticEvent<Element>): void {
		this.setState({ notification: null})
	}

	private handleSubmitAddAccountModal(
		account: Model.Account,
		chapter: Model.Chapter,
		e: React.SyntheticEvent<Element>
	): void {
		e.preventDefault()
		account.number.trim()
		this.setState({ submitting: true })
		const laca: Model.LocalAuthorityChapterAccount = {account, chapter}
		laca.chapter = this.state.chapters.find(ch => ch.id === chapter.id)

		// Appel la méthode qui vérifie si le compte n'existe pas.
		if (this.verifyIfLacaExist(laca)) {
			const notification: NotificationProps = { level: NotificationLevel.Warning, message: "Le compte existe déjà. Veuillez l'affecter à la collectivité via la nomenclature ou vérifiez le numéro."}
			this.setState({ notification, submitting: false })
			return
		}

		LacasService.createLaca(this.props.currentLocalAuthority, laca)
		.then(laca => {
			let lacas = this.state.lacas
			lacas.push(laca)
			lacas = _.sortBy(lacas, laca => laca.account.number)
			this.setState({ lacas })
			this.props.actions.fetchCurrentLocalAuthorityIfNeeded(this.props.currentLocalAuthority.id)
		}, reason => {
			if (reason instanceof ApiError && ApiErrorCode.Unauthorized === reason.getCode())
				this.props.actions.throwError(reason)
			this.setState({ submitting: false })
		})
	}

	private handleSubmitAttachAccountModal(
		acc: Model.Account,
		cha: Model.Chapter,
		e: React.SyntheticEvent<Element>
	): void {
		e.preventDefault()
		const account = this.state.accounts.find(a => a.id === acc.id)
		const chapter = this.state.chapters.find(c => c.id === cha.id)
		const laca: Model.LocalAuthorityChapterAccount = {account, chapter}

		// Appel la méthode qui vérifie si le compte n'existe pas.
		if (this.verifyIfLacaExist(laca)) {
			const notification: NotificationProps = { level: NotificationLevel.Warning, message: "Le compte existe déjà. Veuillez l'affecter à la collectivité via la nomenclature ou vérifiez le numéro."}
			this.setState({ notification, submitting: false })
			return
		}

		LacasService.createLaca(this.props.currentLocalAuthority, laca)
		.then(laca => {
			let lacas = this.state.lacas
			lacas.push(laca)
			lacas = _.sortBy(lacas, laca => laca.account.number)
			this.setState({ lacas })
			this.props.actions.fetchCurrentLocalAuthorityIfNeeded(this.props.currentLocalAuthority.id)
			this.handleClickAttachAccountModalCloseButton(e)
		}, reason => {
			if (reason instanceof ApiError && ApiErrorCode.Unauthorized === reason.getCode())
				this.props.actions.throwError(reason)
			this.setState({ submitting: false })
		})
	}

	private handleSubmitEditAccountModal(
		laca: Model.LocalAuthorityChapterAccount,
		chapter: Model.Chapter,
		account: Model.Account,
		e: React.SyntheticEvent<Element>
	): void {
		e.preventDefault()
		this.setState({ loadingUpdate: true})

		laca.account = account
		laca.chapter = chapter

		let editAccount = this.state.lacas.find(lc => lc.account.id === account.id)

		// Appel la méthode qui vérifie si le compte n'existe pas.
		if (editAccount.account.number!== account.number && this.verifyIfLacaExist(laca)) {
			const notification: NotificationProps = { level: NotificationLevel.Warning, message: "Le compte existe déjà. Veuillez l'affecter à la collectivité via la nomenclature ou vérifiez le numéro."}
			this.setState({ notification, submitting: false })
			return
		}

		LacasService.updateLaca(this.props.currentLocalAuthority, laca).then(
			() => this._resolveUpdateLaca(laca.account, chapter, e),
			reason => {
				if (reason instanceof ApiError && ApiErrorCode.Unauthorized === reason.getCode())
					this.props.actions.throwError(reason)
				this.setState({ submitting: false, loadingUpdate: false })
				this._rejectUpdateLaca(reason)
			}
		)
	}

	private initData(props: InjectedProps) {
		if(!props.currentLocalAuthority) return

		const lacas = _.sortBy(props.currentLocalAuthority.accounts, laca => laca.account.number)

		this.setState({ lacas, loading: true, loadingChapters: true})

		const instructionId = props.currentLocalAuthority.instruction.id

		InstructionsService
		.findInstructionById(instructionId, this.abortController.signal)
		.then(this.resolveFindInstruction, this.rejectFindInstruction)
	}

	private rejectFindInstruction = (reason: any) => {
		if (reason instanceof ApiError && ApiErrorCode.Unauthorized === reason.getCode())
			this.props.actions.throwError(reason)
	}

	private resolveFindInstruction = (instruction: Model.Instruction) => {
		Promise.all([
			InstructionsService.findAccounts(instruction),
			InstructionsService.findChapters(instruction),
			InstructionsService.findClasses(instruction)
		])
		.then(values => {
			const [accounts, chapters, classes] = values
			this.setState({
				accounts,
				chapters,
				classes,
				instruction,
				loading: false,
				loadingChapters: false
			})
		}, reason => {
			if (reason instanceof ApiError && ApiErrorCode.Unauthorized === reason.getCode())
				this.props.actions.throwError(reason)

			this.setState({ loading: false, loadingChapters: false })
		})
	}

	private _resolveUpdateLaca(account: Model.Account, chapter: Model.Chapter, e: React.SyntheticEvent<Element>) {
		let lacas = this.state.lacas
		let lacaIndex = _.findIndex(lacas, laca => laca.account.id === account.id)
		let accounts = this.state.accounts
		let accountIndex = _.findIndex(accounts, acc => acc.id === account.id)

		lacas[lacaIndex].chapter = chapter
		lacas[lacaIndex].account = account
		accounts[accountIndex] = account

		lacas = _.sortBy(lacas, laca => laca.account.number)
		accounts = _.sortBy(accounts, acc => acc.number)

		this.setState({ accounts, lacas, loadingUpdate: false })
		this.handleClickEditAccountModalCloseButton(e)
	}

	private _rejectUpdateLaca(e) {
		this.handleClickEditAccountModalCloseButton(e)
	}

	private verifyIfLacaExist(laca: Model.LocalAuthorityChapterAccount) {
		const lacas = this.state.lacas
		if (lacas.find(lc => lc.account.number === laca.account.number)) return true
		return false
	}
}

function mapDispatchToProps(dispatch: Dispatch<ReducerState>): MappedActionsProps {
	return { actions: bindActionCreators(actionCreators, dispatch) }
}

function mapStateToProps(state: ReducerState): ReducerState {
	return state
}

export default connect(mapStateToProps, mapDispatchToProps)(InstructionList)

export interface Props {
	instructionId: number
}

interface State {
	accountExist: boolean,
	accounts: Model.Account[]
	addLaca: boolean
	attachAccount: boolean,
	classes: Model.Class[]
	chapters: Model.Chapter[]
	editLaca: Model.LocalAuthorityChapterAccount
	lacas: Model.LocalAuthorityChapterAccount[]
	submitting: boolean
	instruction: Model.Instruction
	loading: boolean
	loadingChapters: boolean
	loadingUpdate: boolean
	notification: NotificationProps
}

interface InstructionListParams {
	id: string
}

type InjectedProps =
MappedActionsProps &
Props &
ReducerState &
RouteComponentProps<InstructionListParams>



// WEBPACK FOOTER //
// ./src/component/local-authority/local-authority-detail/instruction-card/instruction-list/index.tsx